import { Component, Inject, OnInit } from '@angular/core';
import {BaseCustomDialog} from "../base-custom-dialog";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'fi-general-message',
  templateUrl: './general-message.component.html',
  styleUrls: ['./general-message.component.scss'],
  standalone: false,
})
export class GeneralMessageComponent extends BaseCustomDialog implements OnInit {
  title = '';
  content = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: { title: string, content: string },
    public dialogRef: MatDialogRef<GeneralMessageComponent>,
  ) {
    super(dialogRef);

    this.title = dialogData?.title ?? '';
    this.content = dialogData?.content ?? '';
  }

  ngOnInit(): void {
  }

  onClosePopup(): void {
    this.clearClassAndCloseDialog(this.dialogRef);

    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  onOverlayClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClosePopup();
    }
  }

}
